// Lista de timezones soportados para LATAM y España
export interface TimezoneOption {
  value: string;          // IANA timezone string
  label: string;          // Nombre legible
  country: string;        // País
  offset: string;         // Offset UTC aproximado (para referencia)
}

export const SUPPORTED_TIMEZONES: TimezoneOption[] = [
  // Argentina
  { value: 'America/Argentina/Buenos_Aires', label: 'Buenos Aires', country: 'Argentina', offset: 'UTC-3' },
  { value: 'America/Argentina/Mendoza',      label: 'Mendoza',       country: 'Argentina', offset: 'UTC-3' },
  { value: 'America/Argentina/Cordoba',      label: 'Córdoba',       country: 'Argentina', offset: 'UTC-3' },

  // Colombia
  { value: 'America/Bogota', label: 'Bogotá', country: 'Colombia', offset: 'UTC-5' },

  // México
  { value: 'America/Mexico_City', label: 'Ciudad de México', country: 'México', offset: 'UTC-6' },
  { value: 'America/Monterrey',   label: 'Monterrey',        country: 'México', offset: 'UTC-6' },
  { value: 'America/Tijuana',     label: 'Tijuana',          country: 'México', offset: 'UTC-8' },

  // Chile
  { value: 'America/Santiago',    label: 'Santiago',   country: 'Chile', offset: 'UTC-4' },
  { value: 'Pacific/Easter',      label: 'Isla de Pascua', country: 'Chile', offset: 'UTC-6' },

  // Perú
  { value: 'America/Lima', label: 'Lima', country: 'Perú', offset: 'UTC-5' },

  // Uruguay
  { value: 'America/Montevideo', label: 'Montevideo', country: 'Uruguay', offset: 'UTC-3' },

  // Costa Rica
  { value: 'America/Costa_Rica', label: 'San José', country: 'Costa Rica', offset: 'UTC-6' },

  // Paraguay
  { value: 'America/Asuncion', label: 'Asunción', country: 'Paraguay', offset: 'UTC-4' },

  // Ecuador
  { value: 'America/Guayaquil', label: 'Guayaquil / Quito', country: 'Ecuador', offset: 'UTC-5' },

  // España
  { value: 'Europe/Madrid', label: 'Madrid', country: 'España', offset: 'UTC+1' },

  // UTC (fallback)
  { value: 'UTC', label: 'UTC', country: 'Universal', offset: 'UTC+0' },
];

/** Devuelve el label legible de un timezone IANA, o el value si no se encuentra */
export function getTimezoneLabel(value: string): string {
  const tz = SUPPORTED_TIMEZONES.find(t => t.value === value);
  return tz ? `${tz.country} – ${tz.label} (${tz.offset})` : value;
}

/** Agrupa los timezones por país para usar en un <select> con <optgroup> */
export function getTimezonesByCountry(): Record<string, TimezoneOption[]> {
  return SUPPORTED_TIMEZONES.reduce<Record<string, TimezoneOption[]>>((acc, tz) => {
    if (!acc[tz.country]) acc[tz.country] = [];
    acc[tz.country].push(tz);
    return acc;
  }, {});
}
